export default "__VITE_ASSET__CDZcEoqO__"